import React, { useEffect, useState } from 'react'

import { browserHistory } from 'react-router'
import { connect } from 'react-redux'

import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core';

import GeneralDataTable from '../core/GeneralDataTable/GeneralDataTable';
import Octagon from '../core/Octagon';
import Toolbar from '../core/Toolbar';
import { colors } from '../theme';
import { notificationDialogSeverity } from '../core/Constants';

import { signup } from '../api';
import { showNotificationDialog } from '../app/AppActions';

import { startCase } from 'lodash'
import moment from 'moment';

//////////////////////////////////////////////////////////////////////////////

const SuperadminLogsTrialRegistrations = (props) => {
    const { reduxDispatch, classes } = props;


    // State for the trial-registration data
    const [registrations, setRegistrations] = useState([]);

    // State-object for table pagination
    const [paginationState, setPaginationState] = useState({
        rowsPerPage: 25,
        page: 0,
    });

    // State-object for table column sorting
    const [columnSortingOptions, setColumnSortingOptions] = useState({
        direction: 'desc',
        column: 'createdAt'
    })


    /**
     * Fetch data using pagination and column sorting information
     */
    useEffect(() => {
        const order = columnSortingOptions.direction === 'desc' ? -1 : 0 ;
        const orderObj = {}
        orderObj[columnSortingOptions.column] = order;

        signup.find({
                $sort: orderObj,
                $limit: paginationState.rowsPerPage,
                $skip: paginationState.rowsPerPage * paginationState.page
            })
            .then(res => {
                setRegistrations(res);
            })
            .catch((err) => {
                reduxDispatch.showMessage(err.message, 'Error', notificationDialogSeverity.error)
            })
    }, [
        paginationState.rowsPerPage,
        paginationState.page,
        columnSortingOptions.direction,
        columnSortingOptions.column,
        reduxDispatch
    ])


    // Table columns
    const columns = [
        { label: 'Name', field: 'name', sortable: true },
        { label: 'Organization', field: 'organization', sortable: true },
        { label: 'Email', field: 'email', sortable: true },
        { label: 'Created', field: 'createdAt', conversion: date => moment(date).format('DD.MM.YYYY HH:mm:ss'), sortable: true },
        { label: 'Success', field: 'success', conversion: value => startCase(value.toString()), sortable: true },
        { label: 'Error', field: 'error', sortable: true },
    ];


//////////////////////////////////////////////////////////////////////////////


    return (
        <Octagon w='80rem' color={colors.octagon}>
            <Toolbar title='Trial Registrations' onGoBack={() => browserHistory.push('/admin/logs')} />
            <Paper className={classes.table} elevation={4}>
                <GeneralDataTable
                    columns={columns}
                    data={registrations}
                    dense
                    columnSortingOptions={columnSortingOptions}
                    onChangeColumnSortingOptions={(newOptions) => setColumnSortingOptions(newOptions)}
                    paginationState={paginationState}
                    onChangePagination={(state) => setPaginationState(state)}
                />
            </Paper>
        </Octagon>
    )
}


//////////////////////////////////////////////////////////////////////////////


const mapStateToProps = (state) => ({
    reduxState: {}
});


const mapDispatchToProps = (dispatch) => ({
    reduxDispatch: {
        showMessage: (message, title, severity) => {
            dispatch(showNotificationDialog(message, title, severity))
        }
    }
})


const styles = theme => ({
    table: theme.containers.dataTable
})


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(SuperadminLogsTrialRegistrations))
